<template>
  <v-app style="margin-top:0px;" >
      <v-card flat v-bind:style="{ 'background-image': 'linear-gradient(to bottom,rgba(243, 177, 55, 0.73), rgba(58, 18, 18, 0.73)), url(' + banner + ')' }" class="tst">
          <v-container>
              <h1 style="margin-top:20px;">{{ countryName }}</h1>
          </v-container>
      </v-card>
<div class="container con" >
      <div class="row" style="margin-top:-100px; " >
        <div class="col-lg-9 col-md-9 col-sm-12" >
      <v-card flat style="border: 1px solid #b6b6b6;">
      <v-container>
          <div class="row" style="padding-top:20px;padding-left:15px;padding-right:15px;text-align: justify;">
            <h2 class="country-heading m-2 " >WHY STUDY ABROAD IN {{ countryName }}</h2>
            <img :src="image" style="width: 50%;height:300px;" />
          <div class="col-lg-12 col-md-12 col-sm-12" style="color:grey;margin-top:50px;">
            <h3 class="country-heading"><strong>Study in Australia</strong></h3>
            <p>Australia, or the Commonwealth of Australia, is a sovereign state made up of the Australian continent's interior, the island of Tasmania, as well as a number of other smaller islands. Australia is the sixth-biggest nation in the world and the largest country in Oceania by area. Australia is the oldest, flattest, driest, and least fertile continent in the world. With deserts in the center, tropical rainforests in the north-east, tropical savannas in the north, and mountain ranges in the south-east, it is a mega diverse nation with a broad diversity of topographies and temperatures.</p>
            <p> Natural resources are abundant in Australia's mixed-market economy, which has a high income. It ranks 18th in PPP and is the thirteenth-largest country in nominal terms in the world. After Luxembourg, it has the second-highest wealth per adult as of 2021, and it ranks thirteenth in terms of financial assets per person. Around 13.5 million people work in Australia, with a 3.5% unemployment rate as of June 2022. The Australian Council of Social Service estimates that 3.2 million Australians, or 13.6% of the population, live in poverty. Additionally, 774,000 (17.7%) children under the age of 15 were predicted to be living in relative poverty. The official currency is the Australian dollar, which is also used by Kiribati, Nauru, and Tuvalu, three Pacific island nations.</p>
            <h4 class="country-heading">Australia as a Study Destination:</h4>
            <p>Australia provides a variety of choices if you want to advance your education, pursue a top-notch degree, or jumpstart your career. In terms of quality of life, academic achievement, and support for international students, Australi-/ is hard to match, whether you decide to pursue an MBA, engineering degree, arts degree, or English language course.</p>
            <p>It is one of the most sought-after locations among Indian students due to its high standard of instruction, wide range of available courses, and post-study employment chances. When you choose to study in Australia, you have access to 22,000 courses offered by 1,100 colleges and institutes, can get degrees that are recognized across the globe, may explore several scholarship options, and can learn from some of the top professors in the world.</p>
            <h4 class="country-heading">Top 10 reasons to study in Australia:</h4>

            <ul>
               <li>We acquire 6 of the top 100 Universities.</li>
               <li>Australia is not far behind in providing one of the best higher education systems in the World.</li>
               <li>Strong emphasis on graduation outcomes and the student experience.</li>
               <li>Australia is home to seven of the world's top student cities.</li>
               <li>More than $300 million has been spent by the Australian government on scholarships for foreign students.</li>
               <li>In a broad range of study fields, our institutions are among the top 50 in the world.</li>
               <li>More than 2.5 million of our graduates from other countries are changing the world.</li>
               <li>16 Nobel laureates have come from our universities.</li>
               <li>High career prospect along with high standard of living.</li>
               <li>Enjoy being a part of a multicultural society.</li>

          </ul>

          <h3 class="country-heading">Student Visa Process:</h3>
          <p>International students frequently choose Australia as their study abroad location because of its top-notch academic opportunities and rich cultural diversity. Studying in Australia can provide you access to highly regarded universities, a variety of academic programs, and career prospects when you graduate. Australia provides students from all over the world with a distinctive and fulfilling study experience because to its high level of living, friendly people, and breathtaking natural environment. The Australian government offers all Indian students the chance to study there, but you must first secure an Australia student visa in order to go there and begin your studies. The sort of study you wish to pursue, the length of the program, and the level of the course will all affect the type of visa you require.</p>
          <h4 class="country-heading">The paperwork needed for an Australian student visa</h4>
          <p>You will typically require the following when applying for your Australia student visa to study there: </p>
          <ul>
            <li>Your electronic confirmation of enrolment, or eCOE, serves as proof of enrollment.</li>
            <li>A current passport</li>
            <li>The charge for applying for a visa</li>
            <li>Academic transcripts and employment history</li>
            <li>Proof of your English language competency (such as IELTS test results)</li>
            <li>Evidence of financial capability, such as proof of education costs, living expenses, dependents' costs, and return airfare</li>
            <li>Specifics of your OSHC health insurance plan</li>
            <li>Passport-sized images</li>
            <li>You will also be required to submit extra documentation, such as parental consent, if you are under the age of 18</li>
          </ul>

          
           <h4 class="country-heading">Online processes:</h4>
           <p>To complete and submit your application for an Australia student visa, you must create an account using the Department of Home Affairs (DHA) online application system, ImmiAccount. Once you have filed your visa, you may check the status of it using ImmiAccount. Your application must be turned in no later than six weeks before the commencement of your course and no sooner than 12 weeks.</p>
           <h4 class="country-heading">The price of education in Australia</h4>
           <p>Your tuition costs will vary depending on the degree program you choose and the institution or school you enroll in. For instance, the cost of veterinary and medical degrees is significantly higher than that of other degrees. In Australia, tertiary schools charge between AUD 20,000 and AUD 30,000 in annual tuition costs.</p>


           <div class="body table-responsive">
                      <table class="table table-bordered" style="margin-top: 10px;">
                          <thead>
                            <tr style="background-color: #f48d8d;">
                              <th style="text-align: center;">Sl No.</th>
                              <th>Study Program</th>
                              <th style="text-align: center;">Average fees in AUD*</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td style="text-align: center;">1</td>
                              <td>School</td>
                              <td style="text-align: center;">$7800-$30000 annually</td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">2</td>
                              <td>English Language Studies</td>
                              <td style="text-align: center;">$350-450 weekly(varies as per course length)</td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">3</td>
                              <td>Vocational Education and Training</td>
                              <td style="text-align: center;">$4000-$22,000 annually</td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">4</td>
                              <td>Undergraduate Bachelor’s Degree</td>
                              <td style="text-align: center;">$15,000-$35,000 annually</td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">5</td>
                              <td>Postgraduate Master’s Degree</td>
                              <td style="text-align: center;">$20,000-$42,000 annually</td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">6</td>
                              <td>Doctoral Degree</td>
                              <td style="text-align: center;">$20,000-$42,000 annually</td>
                            </tr>
                          </tbody>
                        </table>
            </div>


             <h4 class="country-heading">Top Universities in  Australia:</h4>

             <div class="body table-responsive">
                    <table class="table table-bordered" style="margin-top: 10px;">
                        <thead>
                          <tr style="background-color: #f48d8d;">
                            <th style="text-align: center;">Institution</th>
                            <th style="text-align: center;">QS Ranking Globally 2023</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>The Australian National University</td>
                            <td style="text-align: center;">30</td>
                          </tr>
                          <tr>
                            <td>The University of Melbourne</td>
                            <td style="text-align: center;">33</td>
                          </tr>
                          <tr>
                            <td>The University of Sydney</td>
                            <td style="text-align: center;">41</td>
                          </tr>
                          <tr>
                            <td>The University of New South Wales</td>
                            <td style="text-align: center;">45</td>
                          </tr>
                          <tr>
                            <td>The University of Queensland</td>
                            <td style="text-align: center;">50</td>
                          </tr>
                          <tr>
                            <td>University of Adelaide</td>
                            <td style="text-align: center;">109</td>
                          </tr>

                        </tbody>
                      </table>
          </div>
          
          <h4 class="country-heading">The best academic programs in Australia</h4>
          <p>Here is a list of the top programs that foreign students choose to enroll in Australian universities:</p>
          <p>Engineering</p>
          <p>Enterprise Analytics</p>
          <p>A master's degree in business administration (MBA).</p>
          <p>Health Sciences</p>
          <p>(AI) Artificial Intelligence</p>
          <p>Behavioral Sciences</p>
          <p>Medicine</p>

          <h4 class="country-heading">Cost of living in Australia:</h4>

            <div class="body table-responsive">
                  <table class="table table-bordered" style="margin-top: 10px;">
                      <thead>
                        <tr style="background-color: #f48d8d;">
                          <th style="text-align: center;">Living expenses</th>
                          <th style="text-align: center;">Weekly budget (indicative)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Groceries and eating out</td>
                          <td style="text-align: center;">$140 to $280</td>
                        </tr>
                        <tr>
                          <td>Gas, electricity</td>
                          <td style="text-align: center;">$10 to $20</td>
                        </tr>
                        <tr>
                          <td>Phone and Internet</td>
                          <td style="text-align: center;">$15 to $30</td>
                        </tr>
                        <tr>
                          <td>Public Transport</td>
                          <td style="text-align: center;">$30 to $60</td>
                        </tr>
                        <tr>
                          <td>Car(after Purchase)</td>
                          <td style="text-align: center;">$150 to $260</td>
                        </tr>
                        <tr>
                          <td>Entertainment</td>
                          <td style="text-align: center;">$80 to $150</td>
                        </tr>

                      </tbody>
                    </table>
            </div>


          
          <h4 class="country-heading">Documents Required for Higher Study in Australia:</h4>
          <h4 class="country-heading">UG Courses</h4>
             <p>1) Application Form</p>
             <p>2) 10th Mark sheet and Certificate –Notary attested</p>
             <p>3) 12th Mark sheet and Certificate- Notary attested</p>
             <p>4) Passport Copy – First and Last Page – Notary attested</p>
             <p>5) Letters of Recommendation – 2</p>
             <p>6) Statement of Purpose (Duly Signed by Student)</p>
             <p>7) Resume.</p>
             <p>8) IELTS or TOEFL score card if required–Notary attested</p>
             <p>9) Experience certificate – if any</p>
             <p>10) Birth Certificate</p>
             <p>11) Photograph</p>

             <h4 class="country-heading">PG Courses:</h4>
             <p>1) Application Form</p>
             <p>2) 10th Mark sheet and Certificate –Notary attested</p>
             <p>3) 12th Mark sheet and Certificate- Notary attested</p>
             <p>4) Bachelor’s Degree – All individual Mark sheets and consolidated Mark sheet- Notary attested</p>
             <p>5) Degree Certificate or Provisional Degree Certificate- Notary attested 6) Passport Copy – First and Last Page – Notary attested</p>
             <p>7) Letters of Recommendation – 2</p>
             <p>8) Statement of Purpose (Duly Signed by Student)</p>
             <p>9) Resume.</p>
             <p>10) IELTS or TOEFL score card if required–Notary attested</p>
             <p>11) Experience certificate – if any </p>
             <p>12) Birth Certificate</p>
             <p>13) Photograph</p>

              <p class="country-heading">Extension of post-study work privileges for overseas students in Australia for up to an additional two years</p>
              <p>International higher education graduates in Australia who meet the prerequisites will receive an additional two years of post-study employment privileges beginning on July 1, 2023.</p>
              <p>Australia has long given overseas students fantastic post-study employment perks, but officials have now announced yet another modification that would extend the work rights to up to 8 years for some programs. This is a fantastic chance for those overseas students who want to study in this friendly nation as well as those who are already doing so in Australia.</p>
              <p>With the prolonged post-study work rights provided by subclass 485, you can pursue a worldwide career by attending top-ranked Australian universities and institutes.</p>
              <p>Significant Updates</p>
              <p>1. Extending post-study work privileges by two years</p>
              <p>In order to boost the pipeline to skilled employment, the Australian government has proposed a two-year extension of post-study work rights for overseas graduates with certain degrees in fields where there is a confirmed skills shortage. The extension will start on July 1st, 2023.Graduates of overseas higher education who qualify will have an extra two years.</p>
              <p>Post-study employment rights for certain degrees in fields where there are certain skills shortages will expand from:</p>
              <p>For certain bachelor's degrees, two to four years are required.</p>
              <p>For certain master's degrees, three to five years are required.</p>
              <p>For all PhDs, four to six years are required.	</p>
              <p>Significant Updates</p>
              <p>1. Extending post-study work privileges by two years</p>
              <p>The Australian government has released a list of professions and educational requirements that qualify for the extension of post-study work privileges. - Australian Government's Department of Education's list of professions and educational requirements for the extension of post-study work rights</p>
              <p>In addition to the current additional one to two years of work privileges, the extension is available to qualifying students who study, reside, and work in regional areas.</p>
              <p>2. From 1 July 2023, increase the number of hours that can be worked.</p>
              <p>Additionally, the government has stated that starting on July 1, 2023; the limit on part-time employment for overseas students throughout their studies would rise from 40 to 48 hours each week.</p>
              <h4 class="country-heading">Job Prospect in Australia:</h4>
              <p>You must get a new visa if you intend to continue living and working in Australia after completing your education. </p>
              <p>You can be qualified for the Temporary Graduate (subclass 485) visa's Post-Study Work stream if you have earned a Bachelor's, Master's, or Doctoral degree. </p>
              <p>Your new company might be able to sponsor you for a new visa in specific circumstances. To find out if this is feasible, speak with a member of the Human Resources or Recruitment staff at your place of employment.</p>
              <p>You can submit an Expression of Interest (EOI) through Skill Select if you don't have a sponsoring company and wish to live in Australia longer to advance your career.</p>
              <p>Indian students frequently rely on college placements to secure financial aid.</p>
              <p>Indian students frequently rely on college placements to secure employment after graduation. However, there is no such thing as campus recruitment campaigns or placement guarantees overseas; you will need to hunt for suitable employment on your own.</p>
              <p>The career center at your institution will be able to help you with interviews and even put you in touch with potential companies, but the rest is up to you.</p>
              <p>Always maintain a strong network and skill set. During your education, make sure to do appropriate internships and develop solid business communication skills. You might also get letters of recommendation from your lecturers or program coordinators from your university.</p>



           
          </div>     
        </div>
        </v-container>
    </v-card>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12">
          <v-card flat style="background-size:cover;padding:30px;border: 1px solid #b6b6b6;">
                  <div style="background-color:black;color:white;text-align:center;padding:10px;background-image: linear-gradient(to right, #f19a28 , #f12525);background-size:cover;">
                      <h3>Interested in studying abroad?</h3>
                  </div>
                  <v-container v-if="otp==false">
                      <v-form ref="form" v-model="valid" lazy-validation>
                          <v-layout row wrap >
                              <v-flex xs12 style="padding-top:10px;" >
                                  <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;" v-model="form.name" label="Full Name *" :rules="emptyRule" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;"  v-model="form.email" label="Email *" :rules="[rules.email]" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;"  v-model="form.mobileNumber" label="Mobile No *" :rules="[rules.mobileno]" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-autocomplete
                                   outline 
                                   style="background-color:white;height:70px;border-radius:10px;padding: 15px;" 
                                   v-model="selectedCountry"
                                   :items="countries"
                                   color="primary"
                                   label="Preferred Country *"
                                   item-text="countryName"
                                   item-value="countryName"

                                  ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-autocomplete
                                   outline 
                                   style="background-color:white;height:70px;border-radius:10px;padding: 15px;" 
                                   v-model="selectedCourse"
                                   :items="courses"
                                   color="primary"
                                   label="Preferred Course *"
                                   item-text="courses"
                                   item-value="courses"
                                  ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;text-align:center;">
                                  <v-btn :loading="btnSave" large block dark color="primary" @click="getOtp()">Send Message</v-btn>
                              </v-flex>
                          </v-layout>
                      </v-form>
                  </v-container>

                  <v-container v-if="otp==true">
                      <v-form ref="form1" v-model="valid" lazy-validation>
                          <v-layout row wrap>
                              <v-flex xs12>
                                  <label>Enter Your OTP here *</label>
                                  <v-text-field outline style="background-color:white;height:56px" v-model="form1.pin" label="Enter Your OTP here *" :rules="emptyRule" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;text-align:center;">
                                  <v-btn :loading="btnSave1" large block dark color="primary" @click="onSubmit()">Vefity Now</v-btn>
                              </v-flex>
                          </v-layout>
                      </v-form>
                  </v-container>
          </v-card>
          <v-card flat style="background-size:cover;padding:30px;border: 1px solid #b6b6b6; margin-top: 10px;">
            <div style="background-color:black;color:white;text-align:center;padding:10px;background-image: linear-gradient(to right, #f19a28 , #f12525);background-size:cover;">
                      <h3>Universities</h3>
                  </div>
             <marquee direction="up" scrollamount="3" style="margin-top:20px;height:150px ; ">
               <h5 style="margin-bottom:20px;color:#f12525" v-for="item in featuredUniversities" :key="item.id">{{ item.universityName }}</h5>

             </marquee>
          </v-card>

              <div class="">
                <h2 class="m-4" >Global Study <span style="font-weight:600">Destinations</span></h2>
              </div>
            <v-card @click="onCountry(item)" v-for="item in countries" :key="item.id" elevation="10" :style="{backgroundImage: `url(${item.image})`}" class="tourtheme hvr mb-3">
              <div style="margin:0px;cursor: pointer; ">
                <h4 class="mytxt" style="color:whitesmoke;padding:5px;margin:-10px;border-radius: 0px;margin-top: 125px;">{{ item.countryName }}</h4>
              </div>
            </v-card>

        </div>
      </div>
    </div>
      <v-dialog v-model="dialog" width="500px" persistent>
         <v-card>
           <div style="height:150px;background-color:green;text-align:center;">
             <div style="padding-top:25px;">
                <v-icon style="border:1px solid;border-radius:50px;border-color:white;" color="white" :size="80">check</v-icon>
             </div>
           </div>
           <v-container>
             <div style="text-align:center">
                 <h4>Thank You</h4>
                 <h5 class="txt" style="padding-bottom:15px;">Our Counsellors will get back to you !!</h5>
                 <v-btn depressed large color="error" @click="cancel()">Yes Understand</v-btn>
             </div>
           </v-container>
         </v-card>
     </v-dialog>
  </v-app>
</template>

<script>
import config from "../../config.json";
import moment from 'moment';
export default {
  components: {
  },
  data() {
    return {
      tab: null,
      valid: true,
      btnSave: false,
      btnSave1: false,
      dialog: false,
      status: false,
      pin: 0,
      otp: false,
      name: [],
      featuredUniversities: [],

      ielts: true,
      toefl: false,
      gre: false,
      sat: false,
      gmat: false,

      details: null,
      image: null,
      banner: null,
      countryId: null,
      countryName: sessionStorage.getItem("countryName"),

      countries: [],
      selectedCountry: null,

      courses: [],
      selectedCourse: null,

      form: {
        name: null,
        email: null,
        mobileNumber: null
      },
      form1: {
        otp: null
      },
      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
        },
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
      },
    };
    
  },
  
   mounted() {
    // this.axios
    //     .get(config.API + `country/author/${this.$route.params.id}`, {
    //       headers: {
    //         Authorization: "bearer " + sessionStorage.getItem("token")
    //       }
    //     })
    //     .then(res => {
    //       let _data = res.data.author;
    //       this.details = _data;
          
    //       if(_data.image!=null) {
    //         this.image = config.API + 'country/files1/' + _data.image;
    //       }
    //       if(_data.banner!=null) {
    //         this.banner = config.API + 'country/files2/' + _data.banner;
    //         console.log(this.banner);
    //       }
    //     })
    //     .catch(() => {
    //       this.$Progress.fail();
    //     });

      this.countryName = sessionStorage.getItem("countryName");
      this.image = sessionStorage.getItem("image");
      this.banner = sessionStorage.getItem("banner");
      this.countryId = sessionStorage.getItem("countryId");
        this.axios
      .get(config.API + `country/authors`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data.authors;
        console.log(list);

        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          if(element.id!=this.countryId) {
            this.countries.push({
            id: element.id,
            countryName: element.countryName.toUpperCase(),
            src: config.API1 + "country/files/" + element.src,
            image: config.API1 + "country/files1/" + element.image
            })
          }
        }

        console.log(this.countries);
      });

      this.axios
    .get(`https://api.worldwin.org/api/Levels`, {
      headers: { Authorization: "Bearer " + sessionStorage.token }
    })
    .then(res => {
      let list = res.data;
      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        
        this.courses.push(element.levelName)
      }
    });


    this.axios
        .post(
          config.API + `university/search`,
          {
            countryId: this.countryId
          },
          {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          }
        )
        .then(res => {
          let list = res.data.result;
          console.log(list);

          for (let index = 0; index < list.length; index++) {
            const element = list[index];
            
            this.featuredUniversities.push({
              id: element.id,
              universityName: element.universityName,
              src: config.API1 + "university/files/" + element.src
            })
          }
            })
        .catch(err => {
        });
   },

 methods: {
   blg(item) {
     sessionStorage.setItem("blogTitle", item.title);
     sessionStorage.setItem("blogDescription", item.description);
     sessionStorage.setItem("blogSrc", item.src);
     this.$router.push("/blogDetail/" + item.id );
   },
   getOtp() {
    if (this.$refs.form.validate()) {
      this.btnSave = true;
      this.axios
        .post(
          config.API + `enquiry/author`,
          {
            name: this.form.name,
            email: this.form.email,
            mobileNumber: JSON.parse(this.form.mobileNumber),
            country: this.selectedCountry,
            course: this.selectedCourse,
            page: 'Country Details',
            date: moment().format('MMMM Do YYYY')
          },
          {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          }
        )
        .then(res => {
          console.log(res);
          this.name = this.form.name.split(' ');
          let firstName = this.name[0];
          let lastName = null;

          if(this.name.length > 2) {
            lastName = this.name[1] + this.name[2]
          }
          else {
            lastName = this.name[1]
          }

          let comment = "Preferred Country: " + this.selectedCountry + ", Preferred Course: " + this.selectedCourse;
          this.axios
        .post(
          `https://api.worldwin.org/api/Leads1`,
          {
            firstName: firstName,
            lastName: lastName,
            mobileNumber: JSON.parse(this.form.mobileNumber),
            cmsId: JSON.parse(res.data.result.id),
            email: this.form.email,
            guardianName: null,
            comment: comment,
            pageName: 'Country Details',
            guardianNo: 0,
            guardianEmail: null,
            relation: null,
            address: null,
            nature: null,
            source: "Website",
            document: false,
            documentType: null,
            notes: null,
            levelId: 0,
            leadDetails: null,
            leadTrainings: null
          },
          {
            headers: {
              Authorization: "bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(res => {
          this.dialog = true;
          this.btnSave = false;
        })
        .catch(() => {
          this.$toaster.error(`Mobile no is already registered`);
          this.btnSave = false;
        });
        })
        .catch(() => {
          this.$toaster.error("Mobile no is already registered");
          this.btnSave = false;
        });
      }
      /* this.pin = Math.floor(1000 + Math.random() * 9000);
      this.axios
        .post(
          config.API + 'enquiry/otp',
          {
            name: this.form.name,
            mobileNumber: JSON.parse(this.form.mobileNumber),
            otp: this.pin
          },
          {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          }
        )
        .then(() => {
          this.otp = true;
          this.btnSave = false;
        })
        .catch(() => {
          this.$toaster.error("Mobile number already exists!!");
          this.btnSave = false;
        }); */
    /* } else {
      this.$toaster.error(`Required field are empty!!`);
    } */
  },
  onCountry(item) {
  sessionStorage.setItem("countryName", item.countryName);
  sessionStorage.setItem("image", item.image);
  sessionStorage.setItem("banner", item.banner);
  sessionStorage.setItem("countryId", item.id); 
  ////this.$router.push("/countrydetail/" + item.id );
  if(item.countryName=='UK') {
    this.$router.push("/study-in-uk");
  }
  else if(item.countryName=='DUBAI') {
    this.$router.push("/study-in-dubai");
  }
  else if(item.countryName=='SINGAPORE') {
    this.$router.push("/study-in-singapore");
  }
  else if(item.countryName=='USA') {
    this.$router.push("/study-in-usa");
  }
  else if(item.countryName=='AUSTRALIA') {
    this.$router.push("/study-in-australia");
  }
  else if(item.countryName=='CANADA') {
    this.$router.push("/study-in-canada");
  }
  
 },

    onSubmit() {
      if (this.$refs.form1.validate()) {
        if(this.pin == this.form1.otp) {
          this.btnSave1 = true;
        this.axios
          .post(
            config.API + `enquiry/author`,
            {
              name: this.form.name,
              email: this.form.email,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              country: this.selectedCountry,
              course: this.selectedCourse,
              page: 'Test Preparation',
              date: moment().format('MMMM Do YYYY')
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log(res);
            this.name = this.form.name.split(' ');
            let firstName = this.name[0];
            let lastName = null;

            if(this.name.length > 2) {
              lastName = this.name[1] + this.name[2]
            }
            else {
              lastName = this.name[1]
            }
            this.axios
          .post(
            `http://api.worldwin.org/api/Leads1`,
            {
              firstName: firstName,
              lastName: lastName,
              mobileNumber: JSON.parse(this.form.subject),
              cmsId: JSON.parse(res.data.result.id),
              email: this.form.email,
              guardianName: null,
              guardianNo: 0,
              guardianEmail: null,
              relation: null,
              address: null,
              nature: null,
              source: null,
              document: false,
              documentType: null,
              notes: null,
              levelId: 0,
              leadDetails: null,
              leadTrainings: null
            },
            {
              headers: {
                Authorization: "bearer " + localStorage.getItem("token")
              }
            }
          )
          .then(res => {
            this.dialog = true;
            this.btnSave1 = false;
          })
          .catch(() => {
            this.$toaster.error(`Mobile no is already registered`);
            this.btnSave = false;
          });
          })
          .catch(() => {
            this.$toaster.error("Mobile no is already registered");
            this.btnSave1 = false;
          });
        }
        else {
          this.$toaster.error("Please put a valied OTP");
        }
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    cancel() {
      this.form.name = null;
      this.form.email = null;
      this.form.mobileNumber = null;
      this.otp = false;
      this.dialog = false;
    },
 }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');
@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Anton&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Patua+One&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Galada&family=Modak&family=Roboto&family=Roboto+Mono:ital,wght@1,600&display=swap');
</style>

<style scoped>
.banner {
  background-image: url('https://www.pexels.com/photo/selective-focus-photo-of-man-using-laptop-1438081/');
  background-size: cover;
  height:200px;
}
.tst {
  border-radius:0px;
  height:300px;
  background-size: cover;
  color: white !important;
    
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}
.tourtheme {
  height: 190px;
  margin: 15px;
  background-size: 100%;
  transition: background-size 1s ease-in-out !important;
}
.tourtheme:hover {
  background-size: 120%;
}
.partner {
    margin-top: 15px;
    text-align: center;
    font-size: 23px;
    background-image: linear-gradient(to right, #f19a28 , #f12525);
    border-radius: 0px !important;
    color: whitesmoke !important;
}
.country-heading {
  color:#EC1616;
}
.country p {
  font-weight: 300;
  color:#666666;
  text-align: justify;
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offsets {
  top: -50px;
  position: relative;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.v-sheet--offsetf {
  top: -100px;
  position: relative;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
div.scroll { 
                margin:4px, 4px; 
                padding:4px; 
                width: auto; 
                height: 254px; 
                overflow-x: hidden; 
                overflow-x: auto; 
                text-align:justify; 
            }

.themecap {
  font-family: 'Open Sans', sans-serif;
  padding-top: 130px;
  color: white;
}
.top-left {
  font-family: 'Roboto Mono', monospace;
  font-size:40px ;
  padding-top: 200px;
  color: white;
  text-align: center;
}
.salont {
  font-family: 'Patua One', cursive;
}
.link:hover {
  cursor: pointer;
  text-decoration: underline;
}
.hvr:hover {
  cursor: pointer;
  border-radius: 5px !important;
  border : 1px solid;
  border-color: black !important;
  transition-duration: 0.7s;
  text-decoration: none !important;
}
.v-table tbody tr:not(:last-child) {
    border-bottom: none !important;
}
.con {
  margin-top: -100px;
  max-width: 1300px;
}
@media screen and (min-width: 768px){
  .con {
    margin-top: 0px!important;}

  }
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
img.center {
    display: block;
    margin: 0 auto;
}
.recent {
  font-family: 'Nanum Gothic', sans-serif;
}
.srch {
  position: absolute;
  z-index: 10;
  left: 16%;
  top: 0%;
}
.item {
    border:1px solid !important;
}
</style>
